import { CustomComponentProps } from "utils/types/generalTypes";
import SVG from "../core/SVG";
import { useRef } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "services/redux/store";
import { setEmojiModalPostion } from "services/redux/postForm/postForm";
import { setReply } from "services/redux/feedForm/feedForm";
import {
    openEmojiModal,
    openGifModal
} from "services/redux/commentForm/commentForm";

export type CommentFormControlsProps = CustomComponentProps & {
    handleChangeImage: (images: FileList) => void;
    handleChangeVideo: (videos: FileList) => void;
    hideEmoji?: boolean;
};

const CommentFormControls = ({
    handleChangeImage,
    handleChangeVideo,
    hideEmoji,
    className,
    style
}: CommentFormControlsProps) => {
    const imgInputRef = useRef(null);
    const videoInputRef = useRef(null);
    const dispatch = useDispatch<AppDispatch>();

    const emojiBtnRef = useRef(null);

    const openEmoji = () => {
        // @ts-ignore
        const rect = emojiBtnRef.current.getBoundingClientRect();
        console.log("rect", rect);
        const left = rect.left - 50;

        const parentElBottom = rect.bottom;
        // get height of who can see the post modal
        const elHeight = 400;
        // const elHeight = $(el)[0].getBoundingClientRect().height;
        // get window height
        const windowHeight = window.innerHeight;
        let top = 0;
        if (parentElBottom + elHeight - 10 >= windowHeight) {
            // make the elemnt above the btn
            // $(el).css("top", `${parentElBottom - elHeight - 15}px`);
            top = parentElBottom - elHeight - 15;
        } else {
            // make the btn below the btn
            // $(el).css("top", `${}px`);
            top = parentElBottom + 10;
        }

        dispatch(setEmojiModalPostion({ left, top }));
        dispatch(setReply());
        dispatch(openEmojiModal());
    };

    const openGif = () => {
        dispatch(setReply());
        dispatch(openGifModal());
    };

    return (
        <div
            className={`d-flex flex-j-start gap-10 post-form-input-group ${className}`}
            style={style}
        >
            {/* for image  */}
            <div className="post-form-input-container">
                <input
                    className="is-hidden"
                    type="file"
                    name="post-1-img"
                    id="post-1-img-i"
                    multiple
                    onChange={(e) =>
                        handleChangeImage(e.target.files as FileList)
                    }
                    accept="image/png, image/jpeg"
                    ref={imgInputRef}
                />
                <label
                    className="blue-white-text cursor-pointer"
                    onClick={() =>
                        (
                            imgInputRef.current as unknown as HTMLInputElement
                        ).click()
                    }
                >
                    <SVG svg="image" size={24} className="blue-svg" />
                </label>
            </div>
            {/* for video  */}
            <div className="post-form-input-container">
                <input
                    className="is-hidden"
                    type="file"
                    name="post-1-vid"
                    id="post-1-vid-i"
                    accept="video/mp4,video/x-m4v,video/*"
                    ref={videoInputRef}
                    onChange={(e) =>
                        handleChangeVideo(e.target.files as FileList)
                    }
                />
                <label
                    className="blue-white-text cursor-pointer"
                    onClick={() =>
                        (
                            videoInputRef.current as unknown as HTMLInputElement
                        ).click()
                    }
                >
                    <SVG svg="video" size={24} className="blue-svg" />
                </label>
            </div>
            {/* for gif  gifs-modal  */}
            <div className="post-form-input-container">
                <div
                    className="blue-white-text cursor-pointer"
                    onClick={openGif}
                >
                    <SVG svg="gif2" size={24} className="blue-svg" />
                </div>
            </div>
            {/* for poll  */}
            {/* for emoji  */}
            {!hideEmoji && (
                <div className="post-form-input-container p-relative hide-sm">
                    <div
                        className="blue-white-text cursor-pointer"
                        onClick={openEmoji}
                        ref={emojiBtnRef}
                    >
                        <SVG svg="emoji" size={24} className="blue-svg" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default CommentFormControls;
